import { IVideo } from '@gray/domain/models/video/video.model';
import { ILiveStream } from '@gray/domain/models/live-stream/live-stream.model';
import { TContentType } from '@gray/ui/content/content-type-badge/content-type-badge.component';

/**
 * One row of the content library the coach browses. Videos and live streams come from two
 * endpoints but are shown as one list, so they are normalised into a single shape here — what a
 * card needs to draw itself and what an assignment needs to name the content.
 */
export interface IContentItem {
  type: TContentType;
  id: number;
  title: string;
  /** When it went out; a stream that has not aired yet reports the date it is due. */
  date: string | Date | null;
  /** True when the student may open it — a trial student cannot open everything they can see. */
  canView: boolean;
  video?: IVideo | null;
  liveStream?: ILiveStream | null;
}

export function videoToContentItem(video: IVideo): IContentItem {
  return {
    type: 'video',
    id: video.id,
    title: video.title,
    date: video.publishedAt ?? video.createdAt ?? null,
    canView: video.canView !== false,
    video,
  };
}

export function liveStreamToContentItem(liveStream: ILiveStream): IContentItem {
  return {
    type: 'live-stream',
    id: liveStream.id,
    title: liveStream.title,
    date: liveStream.bePublishedAt ?? liveStream.createdAt ?? null,
    // Live streams carry no per-student flag; visibility is already decided by the query.
    canView: true,
    liveStream,
  };
}
